<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <md-card class="">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>calendar_view_month</md-icon>
        </div>
        <h4 class="title">{{ data.label }}</h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-layout-data">
            <md-table class="">
              <md-table-row
                v-for="(row, rowIndex) in data.data"
                :key="rowIndex"
              >
                <md-table-cell
                  >Rooster {{ row["year"] }} week {{ row["week"] }} ({{
                    formatDate(row["start_date"])
                  }})
                </md-table-cell>
                <md-table-cell>
                  <md-button
                    :disabled="disabled"
                    native-type="button"
                    @click.native.prevent="downloadPdf(row)"
                    class="md-success md-button-full-size md-sm"
                  >
                    Download
                  </md-button>
                  <md-button
                    :disabled="disabled"
                    native-type="button"
                    @click.native.prevent="getScheduleHtml(row)"
                    class="md-success md-button-full-size md-sm"
                  >
                    Bekijken
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-row v-if="data.data.length === 0">
                <md-table-cell
                  >Deze widget heeft geen data om weer te geven.
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div class="scheduleViewer" :class="cssClassShowHideHtmlSchedule">
      <div class="md-group">
        <md-button
          class="md-round"
          :class="btnViewTypeImageClass"
          @click.native="htmlSchedule = ''"
          title="Afbeeldingen weergave"
          ><md-icon>close</md-icon>Sluiten
        </md-button>
        <md-button
          v-for="(row, rowIndex) in data.data"
          :key="'htmlView' + rowIndex"
          class="md-round md-sm"
          :class="
            htmlScheduleWeek === row['week'] ? 'md-success' : 'md-default'
          "
          @click.native.prevent="getScheduleHtml(row)"
          title="Lijst weergave"
          >week {{ row["week"] }} ({{ formatDate(row["start_date"]) }})
        </md-button>
      </div>
      <iframe id="scheduleHtmlIframe" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      disabled: false,
      htmlSchedule: "",
      htmlScheduleWeek: 0
    };
  },
  props: ["data"],
  methods: {
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("‑");
    },
    downloadPdf(data) {
      this.notifyVue(
        "PDF rooster " + data.year + " week " + data.week + " download gestart",
        "check",
        "success",
        5000
      );
      this.disabled = true;
      this.$http
        .get(this.$apiBaseUrl + "driver/schedule/" + data.id + "/pdf", {
          responseType: "blob"
        })
        .then(response => {
          this.disabled = false;
          const filename = response.headers.map["content-disposition"][0]
            .split(";")[1]
            .split("filename")[1]
            .split("=")[1]
            .trim()
            .replaceAll('"', "");
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", filename);
          document.body.appendChild(fURL);
          fURL.click();
          document.body.removeChild(fURL);
        });
    },
    getScheduleHtml(data) {
      this.disabled = true;
      this.htmlScheduleWeek = data.week;
      this.$http
        .get(this.$apiBaseUrl + "driver/schedule/" + data.id + "/html", {
          responseType: "blob"
        })
        .then(response => {
          this.htmlSchedule = response.data;

          this.disabled = false;

          let iframe = document.getElementById("scheduleHtmlIframe");

          let frameDoc = iframe.document;
          if (iframe.contentWindow) frameDoc = iframe.contentWindow.document; // IE
          frameDoc.open();
          frameDoc.writeln(this.htmlSchedule);
          frameDoc.close();
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  computed: {
    cssClassShowHideHtmlSchedule: function() {
      return this.htmlSchedule !== "" ? "show" : "hide";
    },
    btnViewTypeImageClass() {
      return this.viewType === "image" ? "md-success" : "md-default";
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-layout-data {
  max-height: 200px;
  overflow-y: auto;
}

div.scheduleViewer {
  background-color: #ffffff;
  position: fixed;
  z-index: 100000;
  width: 99%;
  height: 95vh;
  top: 5px;
  left: 5px;

  &.hide {
    display: none;
  }

  iframe {
    width: 100%;
    height: 90%;
    border: 0;
  }
}
</style>
